<template>
    <div>
        <div class="mt-5 text-center">
            กำลัง Login
        </div>
    </div>
</template>
<script>
import BzbsAuth from '@/core/Account/service/BzbsAuth.js';
import Util from '@/helper/Utility.js';
import Account from '@/helper/AccountHelper.js';
import CacheHelper from "@/helper/CacheHelper.js";
export default {
    name: 'Landing',
    data: function() {
        return {
        };
    },
    created: function() {
        this.initLogin();
    },
    methods: {
        initLogin: async function () {
            let token = this.$route.query.token;
            let cacheHelper = new CacheHelper("session");
            cacheHelper.setCache('dashboard_flashsale', {isshow : true});
            if (token && token != '') {
                token = Util.reShuffleToken(token);
                let isLogin = await this.apiLogin(token);

                if (isLogin) {
                    this.redirectLogin();
                } else {
                    Account.removeCacheUser();
                    this.redirectLogin();
                }
            } else {
                Account.removeCacheUser();
                window.location.replace("/home");
            }
        },
        apiLogin: async function(token) {
            return new Promise((resolve) => {
                BzbsAuth.apiReLoginDevice(token, null).subscribe({
                    next: (data) => {
                        Account.setLogin(data);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        redirectLogin: function() {
            let targetPage = this.$route.query.target_page;
            if (targetPage) {
                window.location.replace("/" + targetPage);
            } else {
                window.location.replace("/home");
            }
        },
    }
}
</script>
